import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { AppComponent } from './app.component';
import { AdminAuthGuard } from './util/admin-auth.guard';
import { DoctorAuthGuard } from './util/doctor-auth.guard';
import { ExternalUserAuthGuard } from './util/external-user-auth.guard';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { PrivacyComponent } from './views/privacy/privacy.component';

const APP_CONTAINERS = [DefaultLayoutComponent];

import { AppAsideModule, AppBreadcrumbModule, AppHeaderModule, AppFooterModule, AppSidebarModule } from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ExcelService } from './services/excel.services';
import { InternalUserAuthGuard } from './util/internal-user-auth.guard';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
	return new TranslateHttpLoader(httpClient, 'assets/i18n/', '.json');
}

@NgModule({
	imports: [
		BrowserModule,
		AppRoutingModule,
		AppAsideModule,
		AppBreadcrumbModule.forRoot(),
		AppFooterModule,
		AppHeaderModule,
		AppSidebarModule,
		PerfectScrollbarModule,
		BsDropdownModule.forRoot(),
		TabsModule.forRoot(),
		ChartsModule,
		HttpClientModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
	],
	declarations: [AppComponent, ...APP_CONTAINERS, P404Component, P500Component, PrivacyComponent],
	providers: [
		{
			provide: LocationStrategy,
			useClass: HashLocationStrategy,
		},
		AdminAuthGuard,
		DoctorAuthGuard,
		ExcelService,
		ExternalUserAuthGuard,
		InternalUserAuthGuard,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
